import Login from "./Login.view";

export default Login;
